// @flow

import { useEffect } from 'react'
import { sendToken } from '../Redux/Actions/Account'
import { useLocation } from 'react-router'
import { useDispatch } from 'react-redux'

function SendToken ({ children }) {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const accessToken = queryParams.get('access_token')
    const subdomain = queryParams.get('subdomain')

    if (accessToken) {
      dispatch(sendToken(accessToken, subdomain))
    }
  }, [])

  return children
}

export default SendToken
